const api = '/item-service/api/external/brands';

export const brandsContext = {
  all: api,
  byId: `${api}/{id}`,
  status: `${api}/{id}/status`,
  logo: `${api}/{id}/logo`,
};
